module.exports = __webpack_public_path__ + "static/media/radiographer.7a7b1f02.jpg";